import { render, staticRenderFns } from "./PendencyDisapprovedData.vue?vue&type=template&id=148bbb30"
import script from "./PendencyDisapprovedData.vue?vue&type=script&lang=js"
export * from "./PendencyDisapprovedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports